export const Logo = ({ className = "h-8" }) => (
  <img src="/brand/logo.webp" alt="tournaopstore" className={`${className} w-auto object-contain`} data-testid="brand-logo" />
);
